function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "none",
  opacity: 0,
  strokeWidth: 0
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m1.641,1.646c.411-.411,1.078-.411,1.489,0l4.87,4.87L12.869,1.646c.411-.411,1.078-.411,1.489,0,.411.411.411,1.078,0,1.489l-4.87,4.87,4.87,4.87c.411.411.411,1.078,0,1.489-.411.411-1.077.411-1.489,0l-4.87-4.87-4.87,4.87c-.411.411-1.078.411-1.489,0-.411-.411-.411-1.078,0-1.489l4.87-4.87L1.641,3.135c-.411-.411-.411-1.078,0-1.489Z",
  fill: "#e1950d",
  fillRule: "evenodd",
  strokeWidth: 0
});

var SvgDeleteCross = function SvgDeleteCross(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-f6006418-cde9-49ec-843a-e864c302c9e4",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete-cross.1276157b.svg";
export { ForwardRef as ReactComponent };